import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import { getDefaultReportsState } from "./state";

const engagementReportsStore = {
  state: getDefaultReportsState(),
  getters,
  mutations,
  actions,
};

export default engagementReportsStore;
